import { Box, ModBox, Text } from '@jfs/ui-new'
import { TextInputWithLabelOnBorder } from './TextInputWithLabelOnBorder'

export const AddEmail = ({ isEditScreen, onPressAddEmail, addEmailEnabled, ...props }: any) => {
  const handleOnPress = () => {
    onPressAddEmail && onPressAddEmail(true)
  }

  return (
    <Box>
      <ModBox show={!addEmailEnabled} underlayColor={'TRANSPARENT'} testID="add-mail" onPress={handleOnPress} marginVertical={3}>
        <Text color={'PRIMARY'} fontFamily={'JioType-Medium'}>
          + Add Email
        </Text>
      </ModBox>
      <ModBox show={addEmailEnabled}>
        <TextInputWithLabelOnBorder {...props} />
      </ModBox>
    </Box>
  )
}
